import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Getledgergroups } from '../store/slices/ledger';
import Loader from "../common/Loader";
import { useDispatch } from "react-redux";
import AdminLayout from './AdminLayout';

const GroupLedgerList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [listGroups, setListGroups] = useState([]);

  useEffect(() => {
    setIsLoading(true);
    dispatch(Getledgergroups())
      .unwrap()
      .then((data) => {
        setListGroups(data || []);
      })
      .catch(({ message }) => {
        console.error("Error fetching groups:", message);
      })
      .finally(() => setIsLoading(false));
  }, [dispatch]);

const renderCategories = (categories) => {
  return (
    <>
      {!categories?.length ? (
        <h2 className="text-center">Ledger Group not found</h2>
      ) : (
        categories.map((group) => (
          <li key={group.id} style={{ listStyle: "none" }}>
            <span
              className="text cursor-pointer"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                e.stopPropagation(); // prevent bubbling
                goToGroupLedger(group.group_name);
              }}
            >
              - {group.group_name}
            </span>

            {Array.isArray(group.children) && group.children.length > 0 && (
              <ul className="sub-categories ms-4 mt-2">
                {renderCategories(group.children)}
              </ul>
            )}
          </li>
        ))
      )}
    </>
  );
};


  const goToGroupLedger = (groupName) => {
    console.log("Navigating to group ledger:", groupName);
  if (groupName === "Closing Stock") {
    navigate("/reports/stocksummary");
  } else {
    navigate(`/group-ledgers/${encodeURIComponent(groupName)}`);
  }
};

  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Group Ledger List</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item"><a href="#">Ledger</a></li>
                <li className="breadcrumb-item active" aria-current="page">Group Ledger List</li>
              </ol>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 mb-2">
              <div className="row mt-3">
                <div className="col-md-12">
                  <div className="card custom-card">
                    <div className="card-body">
                      {listGroups.length > 0 ? (
                        renderCategories(listGroups)
                      ) : (
                        <h5 className="text-center">No groups found</h5>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default GroupLedgerList;
